import { z } from "zod";

/**
 * Mesmas exigências que o `matriculaAlunoSchema` aplica ao tipo Orçamento ('5'),
 * mas sobre o payload enxuto da página pública — aqui não existe o form inteiro
 * da matrícula, só contato e nome do aluno.
 */
export const interessadoSchema = z.object({
  nome: z
    .string()
    .trim()
    .min(1, "Informe seu nome.")
    .refine((nome) => nome.split(/\s+/).length >= 2, "Informe seu nome completo."),
  email: z
    .string()
    .trim()
    .min(1, "Informe seu e-mail.")
    // O e-mail é por onde a secretaria responde: sem domínio completo o
    // orçamento não chega e o contato se perde.
    .regex(/^[^@\s]+@[^@\s.]+(\.[^@\s.]+)+$/, "Informe um e-mail válido."),
  celular: z
    .string()
    .refine((celular) => celular.replace(/\D/g, "").length === 11, "Informe o celular com DDD."),
});

export const alunoSchema = z.object({
  alunoNome: z.string().trim().min(3, "Informe o nome do aluno."),
});

export type InteressadoSchema = z.infer<typeof interessadoSchema>;
export type AlunoSchema = z.infer<typeof alunoSchema>;
